import { FC } from "react";
import { getCardTheme } from "apps/website/utils/content/carousels";
import { Theme } from "apps/website/maps/Theme.map";
import { secureRandomInt } from "libs/utils/misc/src/arrays";

import Grid from "../../layout/Grid/Grid";
import Column from "../../layout/Column/Column";
import ExternalReview, {
  IExternalReview,
} from "../Review/ExternalReview/ExternalReview";
import { rotationClassList } from "../Review/ExternalReview/ExternalReview.map";
import { Layout } from "../Review/Review.map";

export interface ITrustPilotReviewWallProps {
  reviews: IExternalReview[];
  theme?: Theme;
  layout?: Layout;
}

const TrustPilotReviewWall: FC<ITrustPilotReviewWallProps> = ({ reviews, theme = "light-grey", layout }) => (
  <Grid component={TrustPilotReviewWall.name} gap="lg">
    { reviews.map((review) => {
      const rotationClass = rotationClassList[review.testRotation
              ?? Math.floor(secureRandomInt() * rotationClassList.length)];
      return (
        <Column key={ review.title } spans={ { md: 6, lg: 4 } }>
          <ExternalReview { ...review } theme={ getCardTheme(theme) } layout={ layout } className={ `h-full ${rotationClass}` } />
        </Column>
      );
    }) }
  </Grid>
);

export default TrustPilotReviewWall;
